import React, { Component } from "react";
import axios from 'axios';
import api from '../common/api';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import { Container, Row, Col } from "shards-react";
import InputAdornment from '@material-ui/core/InputAdornment';
import Voucher from '../common/vouchers/Voucher';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
	appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: '2rem',
    flex: 1,
    color: 'white'
  },
  paper: {
    padding: '2rem',
    textAlign: 'center',
  },
  checkedIcon:{
	  width: 16,
      height: 16,
  },
  option:{
  	  fontWeight: 600,
      fontSize:'0.75rem',
  },
  typography:{
	  fontSize: '0.75rem'
  },
  select:{
  	marginTop: '0',
  	marginRight:'12px',
  	padding: '0'
  },
  menu:{
  	fontSize: '0.75rem'
  }
});

class PendingVouchers extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
      				providers:{provider:{business_name:''}, options:[], loading: false},
      				work_orders:[],
      				search: false,

		}
  	}

    handleProvidersAsyncChange = async (event, values) =>{
		this.setState({loading: true})
    	var providers = this.state.providers
    	values = (values !== null) ? values :{business_name:''}
		providers.provider = values
    	this.setState({providers: providers})
    	await this.getProviderPendingWorkOrders(providers.provider.id)
		this.setState({loading: false})
    }

    handleProvidersAsyncSearch = (event, values) =>{
    	var provider = values
		const token = localStorage.getItem('userToken')
		if (provider.length > 2) {
			return axios
		     .get(api.providers().index(1,provider,'','','',''),{ headers: {"Authorization" : `Bearer ${token}`} })
		      .then(res => {
		      		var providers = this.state.providers
		      		providers.options = res.data.data
		      		this.setState({providers: providers, search: false})
		      })
		      .catch(err =>{console.log(err)
		      })
		}
    }

    getProviderPendingWorkOrders = (provider_id) => {
		const token = localStorage.getItem('userToken')
		return axios
	     .get(api.providers().pendingToInvoice(provider_id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		var work_orders = this.state.work_orders
	      		work_orders = res.data
	      		this.setState({work_orders: work_orders, search: true})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    handleExpand = (e,id) =>{
    	var work_orders = this.state.work_orders
    	work_orders[id]['expand'] = true
    	this.setState({work_orders: work_orders})
    }

    handleCollapse = (e,id) => {
    	var work_orders = this.state.work_orders
    	work_orders[id]['expand'] = false
    	this.setState({work_orders: work_orders})
    }

    voucherCreated = (e, id) => {
    	var work_orders = this.state.work_orders
    	work_orders[id]['created'] = true
    	this.setState({work_orders: work_orders})
    }

    calculateTotalPrice = (tasks) => {
    	var total_s_iva_price = 0
    	tasks.map((val,idx)=> {
    		total_s_iva_price += parseFloat(val.total_s_iva_price)
    	})
    	return total_s_iva_price;
    }
  	render(){
		const classes = this.props.classes;
  		return(
  			<React.Fragment>
		        <Container fluid className="main-content-container px-4 position-relative">
				<Row noGutters className="page-header">
				  <Typography variant="h6">Facturas a cargar</Typography>
				</Row>
				<Row>
					<div className="row col-12 mb-2 mt-1 ml-2">
						<div className="col-12">
						    <Autocomplete
						      id="provider"
						      style={{ width: 200 }}
						      getOptionLabel={(option) => option.business_name}
							  getOptionSelected={(option, value) => option.business_name === value}			      
						      options={this.state.providers.options}
						      loading={this.state.providers.loading}
						      onInputChange={this.handleProvidersAsyncSearch}
						      onChange={this.handleProvidersAsyncChange.bind(this)}
							  //value={this.state.providers.options.find(v => v.business_name === this.state.providers.provider.business_name) || {}}
						      autoComplete
							  noOptionsText={<Typography variant="caption">Sin resultados</Typography>}
							  name="provider"
						      includeInputInList
						      className="mt-3 mr-2"
						      classes={{
					            option: classes.option,
			        		  }}
						      renderInput={(params) => (
						        <TextField
						          {...params}
						          placeholder="Ingrese un proveedor"
						          InputProps={{
						            ...params.InputProps,
						            endAdornment: (
						              <React.Fragment>
						                {this.state.providers.loading ? <CircularProgress color="inherit" size={20} /> : null}
						                {params.InputProps.endAdornment}
						              </React.Fragment>
						            ),
						          }}
									InputLabelProps={{ ...params.InputLabelProps,
														shrink: true
													}}
									inputProps={{
									            ...params.inputProps,
									            style:{fontSize: '0.75rem', width: 70}
									          }}

						        />
						      )}
						    />
						</div>
						<div className="col-12 mt-2">
							{(this.state.loading) && <CircularProgress />} 
						</div>
						<div className="col-12">
						    {(this.state.search === true && this.state.work_orders.length === 0)
						    	?
							    	'No hay ordenes de trabajo donde falten facturas por cargar'
						    	:
							    	''
						    }
						    {(this.state.work_orders.map((val, idx)=>{
						    	return (
						    		<div>
										<TextField
											id="id"
											name="id"
											margin="normal"
											className="mr-2 mt-1"
											InputLabelProps={{
												shrink: true
											}}
											disabled={true}
											value={val.id}
											inputProps={{style:{fontSize: '0.75rem'}}}
										  	InputProps={{
										        startAdornment: <InputAdornment position="start" ><Typography variant="caption" ># OT</Typography></InputAdornment>,
											}}
										/>
										<TextField
											id="plate"
											name="plate"
											margin="normal"
											className="mr-2 mt-1"
											InputLabelProps={{
												shrink: true
											}}
											disabled={true}
											value={val.vehicle.plate}
											inputProps={{style:{fontSize: '0.75rem'}}}
										  	InputProps={{
										        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Patente</Typography></InputAdornment>,
											}}
										/>
										<TextField
											id="reason"
											name="reason"
											margin="normal"
											className="mr-2 mt-1"
											InputLabelProps={{
												shrink: true
											}}
											disabled={true}
											value={val.reason}
											inputProps={{style:{fontSize: '0.75rem'}}}
										  	InputProps={{
										        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Descripcion</Typography></InputAdornment>,
											}}
										/>
										<TextField
											id="total_s_iva_price"
											name="total_s_iva_price"
											margin="normal"
											className="mr-2 mt-1"
											InputLabelProps={{
												shrink: true
											}}
											disabled={true}
//											value={(val.tasks.length > 0) ? val.tasks[0].total_s_iva_price : 0}
											value={(val.tasks.length > 0) ? this.calculateTotalPrice(val.tasks) : 0}
											inputProps={{style:{fontSize: '0.75rem'}}}
										  	InputProps={{
										        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Monto Total</Typography></InputAdornment>,
											}}
										/>
							            {(val.expand === false || val.expand === undefined)
							            	?
							            		<ExpandMoreIcon onClick={(e)=>{this.handleExpand(e, idx)}} />
							            	:
							            		<ExpandLessIcon onClick={(e)=>{this.handleCollapse(e, idx)}} />
							            }
							            {(val.expand)
							            	?
												(val.created === undefined)
												? 
													<Voucher work_order_id={val.id} providers={(val.budget_to_invoice) ? val.budget_to_invoice.provider : ''} budgets={(val.budget_to_invoice) ? val.budget_to_invoice.id : ''} created={this.voucherCreated} id={idx} default_voucher_type_id={val.type.default_voucher_type_id} can_change_payment_deadline={val.type.can_change_payment_deadline}/>
												:
													<TextField
														id="created"
														name="created"
														margin="normal"
														className="mr-2 mt-1"
														InputLabelProps={{
															shrink: true
														}}
														disabled={true}
														value="Si"
														inputProps={{style:{fontSize: '0.75rem'}}}
													  	InputProps={{
													        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Facturada</Typography></InputAdornment>,
														}}
													/>
								            	:
								            	''
							            }

						    		</div>
					    		)
						    }))}
						</div>
					</div>
				</Row>
				</Container>
			</React.Fragment>
		)
  	}
}
export default withStyles(useStyles)(PendingVouchers);
